import React from 'react';
import { withFormsy } from 'formsy-react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { type FilterItemBaseProps } from '../FilterItemManager';
import useSettings from '../../hooks/useSettings';

function BooleanFilterItem(props: Omit<FilterItemBaseProps<number>, 'placeholder'>) {
	const { t } = useSettings();

	const isDisabled = !!props.defaultValue;

	function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
		props.sendChange(1, event.currentTarget.value);
	}

	return (
		<FormControl className={props.className} fullWidth>
			<RadioGroup name={props.name} className="px-4" value={props.operator} onChange={handleChange} row>
				<FormControlLabel
					disabled={isDisabled}
					value="all"
					control={<Radio />}
					label={t('OPERATOR_BOOL_ALL')}
				/>
				<FormControlLabel
					disabled={isDisabled}
					value="equals"
					control={<Radio />}
					label={t('OPERATOR_BOOL_TRUE')}
				/>
				<FormControlLabel
					disabled={isDisabled}
					value="not_equal"
					control={<Radio />}
					label={t('OPERATOR_BOOL_FALSE')}
				/>
			</RadioGroup>
		</FormControl>
	);
}

export default React.memo(withFormsy(BooleanFilterItem));
